import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { AxiosRequestConfig } from 'axios';

import { getActivities, getActivity, getApplications } from 'api/activityLogService';

/**
 * A custom hook for activities
 *
 * @returns DefinedUseQueryResult<Activity[], Error>
 */
export const useActivitiesQuery = (enabled: boolean, config?: AxiosRequestConfig) => {
  return useQuery({
    queryKey: ['activities', config ? JSON.stringify(config.params) : ''],
    enabled,
    queryFn: () => getActivities(config),
    placeholderData: keepPreviousData
  });
};

/**
 * A custom hook for activities
 *
 * @returns DefinedUseQueryResult<Activity[], Error>
 */
export const useActivityQuery = (id: number, config?: AxiosRequestConfig) => {
  return useQuery({
    queryKey: ['activity', id, config ? JSON.stringify(config.params) : ''],
    queryFn: () => getActivity(id, config)
  });
};

/**
 * A custom hook for activities
 *
 * @returns DefinedUseQueryResult<Activity[], Error>
 */
export const useActivityApplicationsQuery = (config?: AxiosRequestConfig) => {
  return useQuery({
    queryKey: ['activity-applications', config ? JSON.stringify(config.params) : ''],
    queryFn: () => getApplications(config)
  });
};
